// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"4d2045b5","453":"c84edeba","455":"5a6a7905","554":"72770f39","977":"b6d9788b"}[chunkId] + ".chunk.js";
};